/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetSourceMergePreview200ResponseDataSourceToMergeSource } from './GetSourceMergePreview200ResponseDataSourceToMergeSource';
import {
    GetSourceMergePreview200ResponseDataSourceToMergeSourceFromJSON,
    GetSourceMergePreview200ResponseDataSourceToMergeSourceFromJSONTyped,
    GetSourceMergePreview200ResponseDataSourceToMergeSourceToJSON,
    GetSourceMergePreview200ResponseDataSourceToMergeSourceToJSONTyped,
} from './GetSourceMergePreview200ResponseDataSourceToMergeSource';

/**
 * 
 * @export
 * @interface GetSourceMergePreview200ResponseDataSourceToMerge
 */
export interface GetSourceMergePreview200ResponseDataSourceToMerge {
    /**
     * 
     */
    source: GetSourceMergePreview200ResponseDataSourceToMergeSource;
    /**
     * 
     */
    contacts_count: number;
    /**
     * 
     */
    referrals_count: number;
    /**
     * 
     */
    tasks_count: number;
}

/**
 * Check if a given object implements the GetSourceMergePreview200ResponseDataSourceToMerge interface.
 */
export function instanceOfGetSourceMergePreview200ResponseDataSourceToMerge(value: object): value is GetSourceMergePreview200ResponseDataSourceToMerge {
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('contacts_count' in value) || value['contacts_count'] === undefined) return false;
    if (!('referrals_count' in value) || value['referrals_count'] === undefined) return false;
    if (!('tasks_count' in value) || value['tasks_count'] === undefined) return false;
    return true;
}

export function GetSourceMergePreview200ResponseDataSourceToMergeFromJSON(json: any): GetSourceMergePreview200ResponseDataSourceToMerge {
    return GetSourceMergePreview200ResponseDataSourceToMergeFromJSONTyped(json, false);
}

export function GetSourceMergePreview200ResponseDataSourceToMergeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSourceMergePreview200ResponseDataSourceToMerge {
    if (json == null) {
        return json;
    }
    return {
        
        'source': GetSourceMergePreview200ResponseDataSourceToMergeSourceFromJSON(json['source']),
        'contacts_count': json['contacts_count'],
        'referrals_count': json['referrals_count'],
        'tasks_count': json['tasks_count'],
    };
}

export function GetSourceMergePreview200ResponseDataSourceToMergeToJSON(json: any): GetSourceMergePreview200ResponseDataSourceToMerge {
    return GetSourceMergePreview200ResponseDataSourceToMergeToJSONTyped(json, false);
}

export function GetSourceMergePreview200ResponseDataSourceToMergeToJSONTyped(value?: GetSourceMergePreview200ResponseDataSourceToMerge | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'source': GetSourceMergePreview200ResponseDataSourceToMergeSourceToJSON(value['source']),
        'contacts_count': value['contacts_count'],
        'referrals_count': value['referrals_count'],
        'tasks_count': value['tasks_count'],
    };
}

